import React from 'react';
import { Mui } from '@osu/react-ui';

/**
 * StepActions Component for V2
 * Renders action buttons for a step
 */
function StepActions({ step, onAction }) {
  const handleAction = (actionType, actionData) => {
    if (onAction) {
      onAction(actionType, actionData);
    }
  };

  if (!step.actions || step.actions.length === 0) {
    return null;
  }

  return (
    <Mui.Box sx={{ mt: 3, display: 'flex', gap: 2, flexWrap: 'wrap', justifyContent: 'center' }}>
      {step.actions.map((action, index) => (
        <Mui.Button
          key={index}
          variant={action.variant || 'contained'}
          color={action.color || 'primary'}
          size="large"
          onClick={() => handleAction(action.type, action)}
          sx={{ minWidth: '150px' }}
        >
          {action.label}
        </Mui.Button>
      ))}
    </Mui.Box>
  );
}

export default StepActions;